import styled from '@emotion/styled';

const LoanpartButton = styled.button`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 56px;
  margin: 24px 0;
  padding: 12px;
  background-color: ${props => props.theme.secondaryColor};
  border: 1px solid ${props => props.theme.disabledBackgroundColor};
  border-radius: 10px;

  font-family: ${props => props.theme.fontFamily};
  font-size: 18px;
  letter-spacing: -0.06px;
  color: ${props => props.theme.primaryColor};

  cursor: pointer;

  > svg {
    margin-right: 10px;
    display: block;
    height: 16px;
    width: 16px;
    fill: ${props => props.theme.primaryColor};
  }
`;

LoanpartButton.defaultProps = {
  type: 'button',
}

export default LoanpartButton;
